import { useCallback, useMemo, useState } from "react";
import {
    BOARD_MAT_STORAGE_KEY,
    getBoardMatById,
    getGrooveStyleForMat,
    loadBoardMatId,
} from "./boardMatPalette";

/**
 * Active puzzle-board mat color + engraved-groove styling derived from brightness.
 */
export function useBoardMatColor() {
    const [matId, setMatIdState] = useState(loadBoardMatId);

    const mat = useMemo(() => getBoardMatById(matId), [matId]);
    const grooveStyle = useMemo(() => getGrooveStyleForMat(mat.hex), [mat.hex]);

    const setMatId = useCallback((id) => {
        setMatIdState(id);
        try {
            localStorage.setItem(BOARD_MAT_STORAGE_KEY, id);
        } catch {
            /* ignore */
        }
    }, []);

    return { mat, matId, setMatId, grooveStyle };
}
